<li class="access-level-item">
    <RadioButton
        id={idText}
        label={accessLevel.title}
        value={accessLevel.type}
        name={groupName}
        selected={accessLevelType}
        on:selected={fireChangeEvent} />
    {#if accessLevel.canBeSecuredWithPassword && selected}
        <span class="access-level-item-password">
            <TextField
                id="password{accessLevelType}"
                bind:value={password}
                type="text"
                label={terms.passwordWatermark}
                placeholder={terms.passwordWatermark}
                labelHidden={true}
                on:blur={fireChangeEvent}
            />

            <span class="access-level-item-password-note">{terms.passwordDescription}</span>
            {#if isInternetAccessLevel}
                <div class="access-level-item-password-note">{terms.emptyPasswordNote}</div>
            {/if}
        </span>
    {/if}
</li>

<script>
    import { createEventDispatcher } from 'svelte';

    import RadioButton from '@itslearning/prometheus/assets/inputs/RadioButton/v1/RadioButton.svelte';
    import TextField from '@itslearning/prometheus/assets/inputs/TextField/v1/TextField.svelte';
    import { accessLevels } from '../constants';

	const dispatch = createEventDispatcher();

    export let accessLevel = {};
    export let terms = {};
    export let accessLevelType = 0;
    export let password = '';
    export let groupName = '';

    $: idText = `radio_${accessLevel.type}`;
    $: selected = accessLevelType === accessLevel.type;
    $: isInternetAccessLevel = accessLevelType === accessLevels.internet;

    function fireChangeEvent() {
        const data = {
            accessLevelType: accessLevel.type
        };
        
        if (accessLevel.canBeSecuredWithPassword) {
            data.password = password;
        }
        
        dispatch('change', data);
    }
</script>
